import axios from 'axios';

import { CONFIGURACION_SERVICIOS, CONFIGURACION_MEMBRESIAS, CONFIGURACION_PAQUETES, CONFIGURACION_PERFIL } from '../actions/types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

/* Servicios */
export const buscarServiciosConfiguracion = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_servicios`, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_SERVICIOS.BUSCAR,
            payload: res.data.servicios
        });
    } catch (error){ 
        await await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const crearServicioConfiguracion = (servicio) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(servicio);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/crear_servicio`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_SERVICIOS.AGREGAR,
            payload: res.data.servicio
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const obtenerServicioConfiguracion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/detalles_servicio`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_SERVICIOS.DETALLES,
            payload: res.data.servicio
        });
    } catch (error){  
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const limpiarServicioConfiguracion = () => dispatch => {
    dispatch({
        type: CONFIGURACION_SERVICIOS.DETALLES,
        payload: null
    });
}

export const editarServicioConfiguracion = (servicio) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(servicio);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/editar_servicio`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_SERVICIOS.EDITAR,
            payload: res.data.servicio
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){     
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const eliminarServicioConfiguracion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/eliminar_servicio`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_SERVICIOS.ELIMINAR,
            payload: body
        });
        
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

/* Membresias */
export const buscarMembresiasConfiguracion = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_membresias`, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_MEMBRESIAS.BUSCAR,
            payload: res.data.membresias
        });
    } catch (error){ 
        await await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const crearMembresiaConfiguracion = (membresia) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(membresia);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/crear_membresia`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_MEMBRESIAS.AGREGAR,
            payload: res.data.membresia
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const obtenerMembresiaConfiguracion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/detalles_membresia`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_MEMBRESIAS.DETALLES,
            payload: res.data.membresia
        });
    } catch (error){     
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const limpiarMembresiaConfiguracion = () => dispatch => {
    dispatch({
        type: CONFIGURACION_MEMBRESIAS.DETALLES,
        payload: null
    });
}

export const editarMembresiaConfiguracion = (membresia) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(membresia);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/editar_membresia`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_MEMBRESIAS.EDITAR,
            payload: res.data.membresia
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){  
        await dispatch(changeLoader(false));      

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const eliminarMembresiaConfiguracion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/eliminar_membresia`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_MEMBRESIAS.ELIMINAR,
            payload: body
        });
        
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

/* Paquetes */
export const buscarPaquetesConfiguracion = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/listar_paquetes`, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_PAQUETES.BUSCAR,
            payload: res.data.paquetes
        });
    } catch (error){ 
        await await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const crearPaqueteConfiguracion = (paquete) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(paquete);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/crear_paquete`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_PAQUETES.AGREGAR,
            payload: res.data.paquete
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const obtenerPaqueteConfiguracion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/detalles_paquete`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_PAQUETES.DETALLES,
            payload: res.data.paquete
        });
    } catch (error){     
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const limpiarPaqueteConfiguracion = () => dispatch => {
    dispatch({
        type: CONFIGURACION_PAQUETES.DETALLES,
        payload: null
    });
}

export const editarPaqueteConfiguracion = (paquete) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(paquete);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/editar_paquete`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_PAQUETES.EDITAR,
            payload: res.data.paquete
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){  
        await dispatch(changeLoader(false));      

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

export const eliminarPaqueteConfiguracion = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/eliminar_paquete`, body, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_PAQUETES.ELIMINAR,
            payload: body
        });
        
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){ 
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}

/* Perfil */
export const guardarPerfil = (perfil) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/editar_perfil_personal`, perfil, config);
        await dispatch(changeLoader(false));

        await dispatch({
            type: CONFIGURACION_PERFIL.EDITAR_PERSONAL,
            payload: res.data.perfil
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        await dispatch(changeLoader(false));

        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    }
}
